// Centralized Schema.org JSON-LD data and site metadata for SEO.

const origin = (
  import.meta.env.VITE_SITE_URL || 'https://joshuawhastings.com'
).replace(/\/+$/, '');

export const LOGO_URL = `${origin}/assets/images/logo.webp`;
export const PROFILE_IMAGE_URL = `${origin}/assets/images/joshuaw-hastings.jpg`;

const SOCIAL = {
  instagram: 'https://www.instagram.com/joshuawhastings/',
  youtube: 'https://www.youtube.com/@joshuahastingscoach',
};

const SITE_DESCRIPTION =
  'Josh Hastings helps established home-service businesses turn marketing spend into measurable leads, customers, and revenue through smarter marketing systems, lead generation, paid advertising, automation, and growth strategy.';

export const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'ProfessionalService',
  '@id': `${origin}/#organization`,
  name: 'Josh Hastings Marketing Strategy',
  legalName: 'HFE Marketing Group LLC',
  url: `${origin}/`,
  logo: LOGO_URL,
  image: PROFILE_IMAGE_URL,
  description: SITE_DESCRIPTION,
  founder: {
    '@type': 'Person',
    '@id': `${origin}/#josh-hastings`,
    name: 'Josh Hastings',
    jobTitle: 'Home Service Growth Strategist',
    image: PROFILE_IMAGE_URL,
    sameAs: [SOCIAL.instagram, SOCIAL.youtube],
  },
  sameAs: [SOCIAL.instagram, SOCIAL.youtube],
  serviceType: [
    'Home Service Marketing',
    'Marketing Strategy',
    'Lead Generation',
    'Paid Advertising',
    'CRM and Marketing Automation',
    'Funnel Optimization',
    'Growth Consulting',
  ],
};

export const aboutSchema = {
  '@context': 'https://schema.org',
  '@type': 'AboutPage',
  '@id': `${origin}/about#aboutpage`,
  name: 'About Josh Hastings',
  url: `${origin}/about`,
  description:
    'Meet Josh Hastings, a home service growth strategist helping established local and home-service businesses turn marketing into measurable leads, customers, and revenue.',
  mainEntity: {
    '@type': 'Person',
    '@id': `${origin}/#josh-hastings`,
    name: 'Josh Hastings',
    jobTitle: 'Home Service Growth Strategist',
    image: PROFILE_IMAGE_URL,
    description:
      'Josh Hastings is a home service growth strategist helping established local and home-service businesses build smarter marketing systems and more predictable growth.',
    sameAs: [SOCIAL.instagram, SOCIAL.youtube],
  },
};

export const resultsSchema = {
  '@context': 'https://schema.org',
  '@type': 'CollectionPage',
  '@id': `${origin}/results#collection`,
  name: 'Client Results',
  url: `${origin}/results`,
  description:
    'Client results and case studies from businesses working with Josh Hastings.',
};
